import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://iwnlesvxaostlzusfuzu.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml3bmxlc3Z4YW9zdGx6dXNmdXp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQxNzQ5OTUsImV4cCI6MjAzOTc1MDk5NX0.Nqj2fHTiiS6dONenjWEcXgUf4CsjmzbygTY4jrC0V48";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
